import React from 'react';
import {
  FaFileAlt,
  FaFileArchive,
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFilePowerpoint,
  FaFileWord
} from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import { parseAnexos } from '../services/anexosConvocatoria';

// Los anexos de una convocatoria del SEACE, para la sección DOCUMENTOS de las
// dos pantallas (Nuevas Convocatorias y Vigentes).
//
// Las dos comparten el mismo patrón de clases para esas tarjetas —`<prefijo>-doc`,
// `-doc-ic`, `-doc-main`, `-doc-title`, `-doc-sub`—, así que basta con pasarle
// el prefijo del rediseño que toque (`scn9` o `sv17`) y hereda su estilo sin
// duplicar CSS.
const ICONOS = {
  excel: { Icono: FaFileExcel, color: '#1d6f42' },
  pdf: { Icono: FaFilePdf, color: '#b42318' },
  word: { Icono: FaFileWord, color: '#1b5ebe' },
  zip: { Icono: FaFileArchive, color: '#8a5308' },
  ppt: { Icono: FaFilePowerpoint, color: '#c43e1c' },
  plano: { Icono: FaFileAlt, color: '#0f766e' },
  imagen: { Icono: FaFileImage, color: '#6b3fb0' },
  otro: { Icono: FaFileAlt, color: '#5b6470' }
};

const AnexosConvocatoria = ({ texto, prefijo, onAbrir, conFlecha = true }) => {
  const anexos = parseAnexos(texto);
  if (anexos.length === 0) return null;

  return (
    <>
      {anexos.map((anexo) => {
        const { Icono, color } = ICONOS[anexo.tipo] || ICONOS.otro;
        return (
          <button
            type="button"
            key={anexo.url}
            className={`${prefijo}-doc`}
            onClick={() => onAbrir(anexo.url)}
            title={anexo.nombre}
          >
            <span className={`${prefijo}-doc-ic`} style={{ color }}>
              <Icono size={19} aria-hidden="true" />
            </span>
            <div className={`${prefijo}-doc-main`}>
              <div className={`${prefijo}-doc-title`}>{anexo.nombre}</div>
              <div className={`${prefijo}-doc-sub`}>
                {anexo.etiqueta} · se abre en una pestaña nueva
              </div>
            </div>
            {conFlecha && <FiExternalLink className={`${prefijo}-doc-ext`} />}
          </button>
        );
      })}
    </>
  );
};

export default AnexosConvocatoria;
